import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isBetween from "dayjs/plugin/isBetween";
import ICS from "vue-ics";
import "@babel/polyfill";

Vue.use(ICS, { uidDomain: process.env.VUE_APP_DOMAIN, prodId: "TSVS_Agenda" });

dayjs.extend(utc);
dayjs.extend(isBetween);
Vue.prototype.$dayjs = dayjs;

Vue.config.productionTip = false;

Vue.component("text-box-info", () => import("@/components/TextBoxInfo"));

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
